import qweBaseField from "../BaseField"

export default {
    mixins: [qweBaseField],
    data: function () {
        return {
            Step: 0,
            min: 0,
            max: Infinity
        };
    },
    created: function () {
        this.Step = Math.pow(10, 0 - this.selfSetting.Scale);

        if (this.selfSetting.Minimum !== null) {
            this.min = this.selfSetting.Minimum;
        }
        if (this.selfSetting.Maximum !== null) {
            this.max = this.selfSetting.Maximum;
        }
    },

    methods: {
        setValueBeforeHook: function (value) {
            if (value == undefined || value == null) {
                return null;
            }
            else {
                return Number(value);
            }
        },

        relyValueFunSuccess: function (response) {
            if (response.length > 0) {
                this.data[this.name] = this.setValueBeforeHook(response[0]);
            }
            else {
                this.customFun();
            }
        }
    }
}